import { Space } from 'antd';
import styled from 'styled-components';
import { LinkButton } from 'components/atoms/button';
import { BodyLong01, Caption01 } from 'components/styles';

export const Text = styled.p`
  ${BodyLong01};
  color: var(--gray-100);
  margin-bottom: 0;
`;
export const SubText = styled.small`
  ${Caption01};
  color: var(--gray - 80);
`;

export const Container = styled(Space).attrs({
  direction: 'vertical',
  size: 0,
})`
  padding-left: var(--spacing-03);
  max-width: 768px;
`;

export const ModalTriggerButton = styled(LinkButton)`
  margin-top: var(--spacing-05);
`;
